import {createStore, applyMiddleware, compose} from 'redux';
import getAllReducers from '../dataReducers/fetchReducers';
import thunk from 'redux-thunk';

export default function configureStore(appName) {
  const reducers = getAllReducers(appName);
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    reducers,
    {},
    composeEnhancer(
      applyMiddleware(thunk)
    ));
}
